import { gql } from "@apollo/client";
import { APICall } from "../api_helper";

export const CREATE_ROUTINE: APICall = {
  documentNode: gql`
    mutation createRoutine(
      $name: String!
      $routineItems: [NameAndIDInputType]!
      $session: String!
      $eventMetadata: EventMetadata!
    ) {
      createRoutine(
        name: $name
        routineItems: $routineItems
        session: $session
        eventMetadata: $eventMetadata
      ) {
        id
        name
        routineItems {
          id
          name
        }
      }
    }
  `,
  key: "createRoutine",
};

export const LIST_ROUTINES: APICall = {
  documentNode: gql`
    query listRoutines($session: String!) {
      listRoutines(session: $session) {
        id
        name
        routineItems {
          id
          name
        }
      }
    }
  `,
  key: "listRoutines",
};
